module.exports = __webpack_public_path__ + "img/img23.9a52270f.jpg";